module.exports = __webpack_public_path__ + "static/lightning-table-edit-0feb96903af2c6afe52c78f3679fb822.png";